import { EMPLOYER_VENUE_NAME_FETCH_BEGIN, EMPLOYER_VENUE_SEARCH_FETCH_BEGIN } from './action-types'
import type { FetchEmployerVenueNamePayload, SearchEmployerVenuesPayload } from './types'

export const searchEmployerVenues = (payload: SearchEmployerVenuesPayload) => ({
  type: EMPLOYER_VENUE_SEARCH_FETCH_BEGIN as typeof EMPLOYER_VENUE_SEARCH_FETCH_BEGIN,
  payload,
})
export type SearchEmployerVenuesAction = ReturnType<typeof searchEmployerVenues>

export const fetchEmployerVenueName = (payload: FetchEmployerVenueNamePayload) => ({
  type: EMPLOYER_VENUE_NAME_FETCH_BEGIN as typeof EMPLOYER_VENUE_NAME_FETCH_BEGIN,
  payload,
})
export type FetchEmployerVenueNameAction = ReturnType<typeof fetchEmployerVenueName>
